export default 
{
  type: "form-email",
  style: "",
  data: {
    label: "New Email Field",
    placeholder: "sample@abcd.com",
    maxlength: 320,  // {64}@{255}; 64 + 1 + 255 = 320
    minlength: 0,
  },
  children: [],
};
